// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ant-badge {\n\tfont-size: 18px !important;\n}\n\nul.sys-alert {\n\tpadding-left: 16px;\n}", "",{"version":3,"sources":["webpack://./src/components/Alert/style.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;AACnB","sourcesContent":[".ant-badge {\n\tfont-size: 18px !important;\n}\n\nul.sys-alert {\n\tpadding-left: 16px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
